'use client'

import Image from 'next/image'
import { useEffect, useState } from 'react'
import { clientEnv } from '@nwwp/env/client'
import { ANONYMOUS_ID_KEY } from '@nwwp/segment-analytics'
import { encryptLeadForMatch } from '~/actions/encrypt-for-match'
import { ButtonCTA } from '~/components/ButtonCTA'
import { getAnonymousId } from '~/utils/local-storage'
import { getFileFromNwCDN } from '~/utils/nw-cdn'
import { useFunnelStore } from '../_hooks/use-funnel-store'

const ITEMS = [
  <>
    <b>Professional</b> financial advisor recommendations
  </>,
  <>
    Get matched in <b>minutes</b>
  </>,
  <>
    Completely <b>free</b> matching service
  </>,
]

export const MatchHandoff = () => {
  const { data } = useFunnelStore()
  const [ep, setEp] = useState<string | null>(null)

  useEffect(() => {
    void encryptLeadForMatch(data).then(setEp)
  }, [data])

  const getRedirectUrl = () => {
    const queryParams = new URLSearchParams()
    const anonymousId = getAnonymousId()

    if (anonymousId) queryParams.set(ANONYMOUS_ID_KEY, anonymousId)
    queryParams.set('utm_source', 'nerdwallet')
    queryParams.set('utm_medium', 'housead')
    queryParams.set('utm_campaign', 'nwwp_mtkg_internal_011626_redirecttoNWA')
    if (ep) queryParams.set('ep', ep)

    return `${clientEnv.NEXT_PUBLIC_MATCH_URL}/age?${queryParams.toString()}`
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-4xl bg-card p-6 text-foreground">
        <div className="flex flex-col items-center justify-between gap-6 tablet:flex-row">
          <div className="flex flex-col gap-6">
            <div className="relative h-10 w-[137px]">
              <Image
                src="https://cdns3.nerdwallet.com/nerdwallet-advisors/nwa-match-small-logo.png"
                alt=""
                fill
                sizes="137px"
                className="object-contain"
              />
            </div>
            <p className="text-body-bold-lg">
              We&apos;ll match you to a financial advisor that could help you with your financial goals
            </p>
            <ul className="flex flex-col gap-4 px-0 tablet:px-4">
              {ITEMS.map((label, index) => (
                <li key={index} className="flex gap-3 text-body">
                  <span aria-hidden>+</span>
                  <span>{label}</span>
                </li>
              ))}
            </ul>
          </div>
          <Image src={getFileFromNwCDN('match-handoff-image@2x-20260116.webp')} alt="" width={314} height={332} />
        </div>
        <ButtonCTA
          href={getRedirectUrl()}
          variant="match"
          className="mt-6 w-full"
          segmentElement="RedirectToMatchButton"
        >
          Continue to Advisors Match
        </ButtonCTA>
      </div>
      <p className="rounded-lg px-4 py-2 text-body-sm text-white">
        Unpaid non-client promotion. NerdWallet Wealth Partners, LLC and NerdWallet Advisory LLC are affiliated
        entities, therefore, NerdWallet Wealth Partners, LLC has a financial incentive to promote the advisory services
        offered by NerdWallet Advisors LLC. NerdWallet Wealth Partners, LLC also participates in the NerdWallet Advisors
        Match program.
      </p>
    </div>
  )
}
